/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1AppsCreateAppResponseData = {
  /**
   * The unique identifier of the newly created app, generated by Teral.
   *
   * @remarks
   * Always begins with 'app_' followed by a unique alphanumeric sequence.
   */
  appId: string;
};

/** @internal */
export const V1AppsCreateAppResponseData$inboundSchema: z.ZodType<
  V1AppsCreateAppResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  appId: z.string(),
});

export function v1AppsCreateAppResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1AppsCreateAppResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1AppsCreateAppResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1AppsCreateAppResponseData' from JSON`,
  );
}
